import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryQuickLinks() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-14 bg-background-100">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-6">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-label font-semibold uppercase tracking-wider text-primary-600">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
            Category
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">分类快捷入口</h2>
        </div>
        <Link
          to="/category/all"
          className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          全部分类
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="flex gap-3 overflow-x-auto no-scrollbar pb-1 -mx-4 px-4 md:mx-0 md:px-0 md:grid md:grid-cols-4 lg:grid-cols-8 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.key}
            to={`/category/${encodeURIComponent(cat.key)}`}
            className="group shrink-0 w-28 md:w-auto flex flex-col items-center gap-3 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span className="w-12 h-12 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={`${cat.icon} text-2xl`} />
            </span>
            <span className="font-heading text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
              {cat.name}
            </span>
            <span className="text-xs text-foreground-500">{cat.count} 部</span>
          </Link>
        ))}
      </div>
    </section>
  );
}